// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

//TEMP, remove once the DEBUG navigate is removed
import { Router } from '@angular/router';
//TEMP

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';
import { exportCsvDTO } from '../../shared/library/export';

//Models
import { dto_for_DV1_AddTranslation_Request } from "../../shared/dtos/practices/dto_for_DV1_AddTranslation_Request.js";
import { dto_for_DV1_UpdateTranslation_Request } from "../../shared/dtos/practices/dto_for_DV1_UpdateTranslation_Request.js";

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormAction } from "../../shared/classes/formAction";



// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// TranslationAssetsComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.tran-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.tran-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.tran-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.tran-legend-item-div{margin:0 16px 0 2px}.tran-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.tran-control-lbl{margin-right:4px}.tran-filter-radio{padding-left:10px;display:flex;align-items:center}.tran-main-control-break{flex-basis:100%;height:0}.tran-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.tran-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.tran-ui-flex-field-div{margin:0 0 0 0;display:flex;align-items:center}.tran-ui-flex-field-lbl{white-space:nowrap;flex-wrap:nowrap}.tran-upper-div{flex-grow:0}.tran-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.tran-ui-popup-edit{width:625px;max-width:625px;overflow:hidden}.tran-ui-popup-export{width:500px;max-width:500px}.tran-ui-dates-block{display:flex}.tran-cssClasses_Grid{border-top:solid 1px #bbb}.tran-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.tran-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.tran-cssClasses_EditableCell_complete{border:solid 1px green !important}.tran-cssClasses_Grid_MS{border-bottom:none !important}.tran-cssClasses_Body_MS{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.tran-cssClasses_Cell_MS{padding:0 2px !important}.tran-list{width:75px;height:80px;border:solid 1px #b8b8b8;padding:2px;overflow-y:auto;background-color:#f0f0f0}.tran-list-button{margin:0 5px;font-size:18px}'],
    template : '<!--Content Div-->\n<div class="tran-main-content-div" data-test-id="content_translation_view">\n\n    <!--=========================================================================================-->\n    <!--Upper Content Area-->\n    <!--=========================================================================================-->\n    <div class="tran-upper-div">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Title -->\n        <!-- ---------------------------------------------------- -->\n        <h2 tabindex="-1" class="cpd-title-div">CPDES Language Translation</h2>\n\n        <!--ENTITY Dropdown-->\n        <div class="tran-control-div">\n\n            <label class="tran-control-lbl">Select Target: <span class="cpd-required">*</span></label>\n            <select id="selEntity" [(ngModel)]="_selectedEntity" (change)="entityChanged($event)" aria-label="Select Target" aria-required="true" style="min-width:200px;">\n                <option *ngFor="let entity of _entities;" [ngValue]="entity">{{entity}}</option>\n            </select>\n\n            <div style="width:20px;"></div>\n        </div>\n\n        <div style="border-top:solid 1px #ccc; margin:15px;"></div>\n\n        <div *ngIf="this._selectedEntity == \'Assets\'">\n            <!--Language Filter-->\n            <div class="tran-control-div" style="margin:5px 0 10px 0">\n\n                <label class="tran-control-lbl">Select Language: <span class="cpd-required">*</span></label>\n                <select id="selLanguageCategoryFilter" [(ngModel)]="_selectedLanguage" (change)="languageChanged($event)" aria-label="Select Language" aria-required="true">\n                    <option *ngFor="let language of _languages;" [ngValue]="language">{{language.language_name}}</option>\n                </select>\n\n            </div>\n        </div>\n\n        <!--Data Controls-->\n        <div *ngIf="this._selectedEntity == \'Assets\' && this._isLanguageSelected" class="tran-control-div" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <div id="divRadioLabel">Filter By:</div>\n\n            <!--ALL-->\n            <div class="tran-filter-radio" (click)="translationFilterUpdated(\'all\')" (keyEnter)="translationFilterUpdated(\'all\')">\n                <input tabindex="0" id="rdoShowAll" type="radio" value="all" name="translationFilter" [(ngModel)]="_selectedTranslationFilter" />\n                <label for="rdoShowAll" class="cpd-focusable">All</label>\n            </div>\n\n            <!--ACTIVE-->\n            <div class="tran-filter-radio" (click)="translationFilterUpdated(\'active\')" (keyEnter)="translationFilterUpdated(\'active\')">\n                <input tabindex="0" id="rdoShowActive" type="radio" value="active" name="translationFilter" [(ngModel)]="_selectedTranslationFilter" />\n                <label for="rdoShowActive" class="cpd-focusable">Active</label>\n            </div>\n\n            <!--INACTIVE-->\n            <div class="tran-filter-radio" (click)="translationFilterUpdated(\'inactive\')" (keyEnter)="translationFilterUpdated(\'inactive\')">\n                <input tabindex="0" id="rdoShowInactive" type="radio" value="inactive" name="translationFilter" [(ngModel)]="_selectedTranslationFilter" />\n                <label for="rdoShowInactive" class="cpd-focusable">Inactive</label>\n            </div>\n\n            <div style="min-width:10px; min-height:20px; border-left:solid 1px #999; margin-left:10px;"></div>\n\n            <!--ASSET TYPE FILTER-->\n            <div>\n                <label for="selAssetTypeFilter" aria-label="Asset Type Filter" title="Asset Type Filter">Asset Type:</label>\n                <select id="selAssetTypeFilter" [(ngModel)]="_selectedAssetTypeFilter" (change)="assetTypeFilterChanged($event)">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n        </div>\n\n    </div>\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Grid Div -->\n    <!-- ---------------------------------------------------- -->\n    <div *ngIf="this._selectedEntity == \'Narratives\'" class="cpd-subtitle-div" style="padding-left:10px;">Coming soon!</div>\n    <ng-container *ngIf="this._selectedEntity == \'Assets\' && this._isLanguageSelected">\n        <div class="tran-main-grid-div">\n            <cas-grid #assetGrid\n                      summary="Assets"\n                      [settings]="_assetGridSettings"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        </div>\n    </ng-container>\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="translation_asset_page_popups"></div>\n\n    <!--========================================-->\n    <!-- Asset Translation Edit Popup -->\n    <!--========================================-->\n    <modal #popEditAssetTranslation\n           title="Update Asset Translation"\n           containerId="translation_asset_page_popups"\n           label="popEditAssetTranslation"\n           customClass="tran-ui-popup-edit">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_edit_asset_translation"></section>\n\n        <!-- body -->\n        <section>\n\n            <!--Single Row display-->\n            <div id="popupAssetTranslationFields" class="cpd-ui-row">\n\n                <!--Single Cell display-->\n                <div class="tran-ui-cell" style="flex-grow:1; padding-bottom:15px;">\n\n                    <!--Selected Practice Display-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Asset" attr.aria-label="Asset"><h3>Asset</h3></div>\n                    <div>\n                        <span style="font-weight:bold;margin-right:5px;">Asset Code:</span><span>{{_selectedAssetCode}}</span>\n                        <span style="font-weight:bold;margin:0 5px 0 20px;">Asset Name:</span><span>{{_selectedAssetName}}</span>\n                        <span style="font-weight:bold;margin:0 5px 0 20px;">Asset Type:</span><span>{{_selectedAssetType}}</span>\n                    </div>\n                </div>\n            </div>\n            <div id="popupAssetTranlationInput" class="cpd-ui-row">\n                <!--Spacer-->\n                <div style="height:30px;"></div>\n\n                <div class="tran-ui-cell" style="flex-grow:1; padding-bottom:15px;">\n                    <!--Edit Translation Section-->\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="5" title="Translation" attr.aria-label="Translation"><h3>Translation</h3></div>\n\n                    <div>\n                        <span style="font-weight:bold;margin-right:5px;">Language:</span><span>{{_selectedLanguage.language_name}}</span>\n                    </div>\n\n                    <div>\n                        <label for="asset_name_translation" style="margin-top:10px;font-weight:bold;">\n                            Asset Name Translation:\n                        </label>\n                        <div>\n                            <textarea id="asset_name_translation"\n                                      rows="6" style="width:100%;" name="attribute_value"\n                                      data-cval-msg-element-id="asset_translation_vmsg"\n                                      data-cval-fld-name="Asset Translation"\n                                      [attr.maxLength]="2000"\n                                      [attr.data-cval-required]="true"\n                                      class="cval"\n                                      [ngModel]="_attribute_value" (ngModelChange)="_attribute_value=$event"></textarea>\n                        </div>\n                        <!--validation message-->\n                        <div id="asset_translation_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                    <div class="cpd-ui-field-div">\n                        <label for="publish" style="width:50px;font-weight:bold;text-align:left;">Publish</label>\n                        <input type="checkbox"\n                               *ngIf="!this._publish"\n                               id="publish" name="publish"\n                               [ngModel]="_publish" (ngModelChange)="_publish=$event" />\n\n                        <input type="checkbox"\n                               *ngIf="this._publish"\n                               id="publish" name="publish"\n                               onclick="return false;"\n                               role="application"\n                               aria-disabled="true"\n                               aria-label="Publish checkbox"\n                               [ngModel]="_publish" />\n                    </div>\n\n                </div>\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal();">Cancel</button>\n            <button type="button" accesskey="s" class="btn btn-primary" (click)="saveTranslation()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Export Translations Popup -->\n    <!--========================================-->\n    <modal #popExportTranslations\n           containerId="translation_asset_page_popups"\n           title="Asset & Narrative Translations Export"\n           label="popExportTranslations"\n           customClass="tran-ui-popup-export">\n\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_asset_narrative_translations_export"></section>\n\n        <!-- body -->\n        <section>\n\n            <div class="tran-control-div" style="margin:5px 0 10px 0">\n\n                <label class="tran-control-lbl">Select Language: <span class="cpd-required">*</span></label>\n                <select id="selLanguageExportFilter" [(ngModel)]="_selectedExportLanguage" aria-label="Select Language" aria-required="true" >\n                    <option *ngFor="let language of _languagesExport;" [ngValue]="language">{{language.language_name}}</option>\n                </select>\n\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" (click)="exportTranslations()">Export</button>\n        </footer>\n\n    </modal>\n\n</div>\n',
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})

export class TranslationAssetsComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('assetGrid') assetGrid;
    @ViewChild('popEditAssetTranslation') popEditAssetTranslation;
    @ViewChild('popExportTranslations') popExportTranslations;

    //Class wide member reference for the growls control
    growlBox = null;

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'translationAssets.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'translation'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    _popupDirty = false;
    _sessionStorageObject = null;

    //Data
    _selectedRow = null;
    _selectedAssetId = null;
    _selectedAssetCode = "";
    _selectedAssetName = "";
    _selectedAssetType = "";
    _selectedTranslationId = null;
    _entities = [];
    _selectedEntity = "";
    _assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code: "" }];
    _selectedAssetTypeFilter = this._assetTypeFilters[0];
    _isActiveFilter = null;
    _isInactiveFilter = null;
    _selectedTranslationFilter = 'all';

    _languages = [{ language_id: 0, language_name: "" }];
    _selectedLanguage = this._languages[0];
    _isLanguageSelected = false;
    _languagesExport = [{ language_id: 0, language_name: "" }];
    _selectedExportLanguage;

    _entity_name = "d_practice";
    _attribute_name = "practice_name";
    _attribute_value = "";
    _previousAttributeValue = "";
    _publish = false;
    _previousPublish = false;

    //Asset Grid
    _assetGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox: false,
        multiSelect: false,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "practice_code",
        rowIdentityPrefixForJAWS: "Asset Code",
        cssClasses_Grid: "tran-cssClasses_Grid",
        cssClasses_Cell: "tran-cssClasses_Cell",
        columns: [
            { fieldName: 'practice_code', display: 'Code', width: '10%' },
            { fieldName: 'practice_type_code', display: 'Asset Type', width: '10%' },
            { fieldName: 'practice_name', display: 'Asset Name', width: '25%' },
            { fieldName: 'attribute_value', display: 'Translation', width: '30%' },
            { fieldName: 'publish', display: 'Translation Published', width: '5%', minWidth: 75 },
            { fieldName: 'creation_date', display: 'Translation Create Date', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' },
            { fieldName: 'last_change_date', display: 'Last Updated Date', width: '8%', minWidth: 50, procDataFn: this._formatDate.bind(this), dataType: 'date' }
        ]
    };



    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        this._disableControls = false;

        // Validation
        //--------------
        this.casValidate = new CASValidate(this);

        //Init the local storage for this page
        this._sessionStorageObject = this._loadSessionStorageObject();

        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedTranslationEntity: null
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        // Growl Prep
        //--------------------
        this.initalizeGrowlBox();

        // Load entities
        this.initEntities();
        if (this._sessionStorageObject.selectedTranslationEntity == "Assets") {
            this._selectedEntity = this._sessionStorageObject.selectedTranslationEntity;
        }

        //this._previousPage = this.casNavBoxService._previousUrl;
        this._isFromTaggingPage = this.casNavBoxService._previousUrl.indexOf('translation') > -1 ? true : false;

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = this._selectedEntity != "" && this._isFromTaggingPage ? document.getElementById("selEntity") : document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        // Load the form fields
        //-----------------------------------
        this.casNavBoxService.ActionsLoading = true;
        this.loadActionLinks();

        this.loadAssetTypes(() => {
            this.loadLanguages(() => {
                this.ngOnInit_Complete();
            });
        });

    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    ngOnInit_Complete() {
        this.casValidate.initialize(true);

        this._pageLoading = false;
    };

    //========================================
    // initalizeGrowlBox
    //========================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    }

    // EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // assetTypeFilterChanged
    //==================================
    assetTypeFilterChanged(e) {

        this.initAssetGrid();
        
    };

    //==================================
    // entityChanged
    //==================================
    entityChanged(e) {

        var dropDown = document.getElementById("selEntity");
        dropDown.focus();
        this.casNavBoxService._previousUrl = "/cpdes/translation/assets";

        //Save seleted entity to session
        if (this._selectedEntity) {
            this._sessionStorageObject.selectedTranslationEntity = this._selectedEntity;
            this._saveSessionStorageObject(this._sessionStorageObject);

            //Load grid according to selected entity
            switch (this._selectedEntity) {
                case "Assets":
                    this._isLanguageSelected = false;
                    this._selectedLanguage = this._languages[0];

                    break;

                case "Narratives":
                    let routeNarratives = "/cpdes/translation/narratives";
                    this.router.navigate([routeNarratives]);

                    break;

                default:
                    break;
            }

        }
        else {
            this._isLanguageSelected = false;
            this.loadActionLinks();
            this._sessionStorageObject.selectedTranslationEntity = null;
            this._saveSessionStorageObject(this._sessionStorageObject);
        }

    };

    //==================================
    // _formatDate
    //==================================
    _formatDate(dateString) {
        return this.cpdFormatters.formatDateString(dateString);
    };


    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        if (this.assetGrid) {
            this.assetGrid.MarkAsLoading(true);
        }
        else {
            this.assetGrid.loading = true;
        }
        this._selectedRow = null;

        // Refresh grid
        this.initAssetGrid(() => {
            this.ngOnInit_Complete();
            this.assetGrid.MarkAsLoading(false);
        });
    };


    //==================================
    // languageChanged
    //==================================
    languageChanged(e) {

        if (this._selectedLanguage.language_name == "") {
            this._isLanguageSelected = false;
        }

        else {
            this._isLanguageSelected = true;

            this.markAssetGridAsLoading(true);
            this.initAssetGrid(() => {
                this.ngOnInit_Complete();
                this.markAssetGridAsLoading(false);
            });
        }
        this.loadActionLinks();

    };

    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {
        if (!action || !action.field_name) { return; }

        switch (action.field_name.toLowerCase()) {

            case "act_edit_translation":
                if (this._selectedEntity == "") {
                    this.growlBox.addGrowl("info", "Please select a Target");
                    return;
                }
                if (!this._isLanguageSelected) {
                    this.growlBox.addGrowl("info", "Please select a Language for editing");
                    return;
                }

                //Make sure a row was selected
                let selectedRow = this.assetGrid.GetFirstSelectedRow();
                if (!selectedRow) {
                    this.growlBox.addGrowl("error", "Please select an asset to edit.");
                    return;
                }

                this.action_openEditTranslation();
                break;

            case "act_asset_narrative_translation_export":
                this.action_exportAssetNarrativeTranslations();
                break;
        }

    };


    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText) {

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.assetGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_name.toLowerCase().indexOf(searchText) >= 0
                || (row.attribute_value ? row.attribute_value.toLowerCase().indexOf(searchText) >= 0 : false);
        };

        //Set the "search" filter on the grid
        this.assetGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    };


    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //==================================
    // translationFilterUpdated
    //==================================
    translationFilterUpdated(filter) {

        //jump out for unrecognized filters
        if ("all,active,inactive".indexOf(filter) < 0) {
            throw ("[translationAssets:_translationFilterUpdated] Unrecognized filter");
        }

        switch (filter) {
            case "all":
                this._isActiveFilter = false;
                this._isInactiveFilter = false;

                break;

            case "active":
                this._isActiveFilter = true;
                this._isInactiveFilter = false;

                break;

            case "inactive":
                this._isActiveFilter = false;
                this._isInactiveFilter = true;

                break;

            default:
                break;
        }

        //Set the member value
        this._selectedTranslationFilter = filter;

        //Clear any search box filters
        this.assetGrid.ClearFilter("search", false);
        this.assetGrid.ClearSearchBox();

        this.initAssetGrid();
    };


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // action_exportAssetNarrativeTranslations
    //=======================================
    action_exportAssetNarrativeTranslations() {
        this._selectedExportLanguage = this._languagesExport[0];

        this.popExportTranslations.Open();
    }

    //=======================================
    // action_openEditTranslation
    //=======================================
    action_openEditTranslation() {

        let selectedRow = this.assetGrid.GetFirstSelectedRow();

        this._selectedAssetId = selectedRow.practice_id;
        this._selectedAssetCode = selectedRow.practice_code;
        this._selectedAssetName = selectedRow.practice_name;
        this._selectedAssetType = selectedRow.practice_type_code;
        this._selectedTranslationId = selectedRow.language_translation_id;
        this._attribute_value = selectedRow.attribute_value;
        this._previousAttributeValue = selectedRow.attribute_value;
        this._publish = selectedRow.publish && selectedRow.publish.toUpperCase() == 'Y' ? true : false;
        this._previousPublish = this._publish;

        this.popEditAssetTranslation.Open();

    };

    //=======================================
    // closeModal
    //=======================================
    closeModal() {
        //Refresh all references to the updated list
        
    };

    //=======================================
    // exportTranslations
    //=======================================
    exportTranslations() {

        //Validaton
        if (this._selectedExportLanguage.language_name == "") {
            alert("Please select a language.");
            return;
        }

        //Export
        try {
            this.growlBox.addGrowl("info", "Exporting Asset & Narrative Translations...");
            this.popExportTranslations.Close();

            this.webServices.Get({
                apiPath: "/translation/exportAssetNarrativeTranslations",
                args: {
                    languageId: this._selectedExportLanguage.language_id,
                }
            })
                .then(res => {

                    console.log("[{0}:exportTranslations():/translation/exportAssetNarrativeTranslations] - res:".format(this._componentName), res);

                    if (!res.data.DTO || res.data.DTO == "") {
                        this.growlBox.addGrowl("info", "No records found for the indicated search.");
                        return;
                    }

                    this.growlBox.addGrowl("success", "Export complete. Sending file to browser.");

                    //Popup in new window
                    exportCsvDTO(res.data.DTO, 'Asset-Narrative-Translations', this._selectedExportLanguage.language_name);
                })
                .catch(err => {
                    console.log("An error occured while exporting.", this.cpdFormatters.formatError(err));
                    this.growlBox.addGrowl("error", "An error occured while exporting.");
                });
        }
        catch (e) {
            console.log("An unexpected error occured while exporting", this.cpdFormatters.formatError(e));
            this.growlBox.addGrowl("error", "An unexpected error occured while exporting");
        }
    }


    //=======================================
    // initEntities
    //======================================
    initEntities(fnOnComplete) {
        this._entities = ["", "Assets", "Narratives"];
        this._selectedEntity = this._entities[0];

        if (fnOnComplete) { fnOnComplete(); }

    };

    //=======================================
    // initAssetGrid
    //======================================
    initAssetGrid(fnOnComplete) {
        this.markAssetGridAsLoading(true);

        this.loadAssets((dto) => {

            this._publish = (dto.publish && dto.publish.toUpperCase() == 'Y') ? true : false;
            this._previousPublish = this._publish;

            this._selectedRow = null;
            if (this.assetGrid) {
                this.assetGrid.SetRows(dto);
                console.log("Asset Grid init".format(this._componentName, this._formName));
                this.markAssetGridAsLoading(false);
            }
            else {
                this._assetGridSettings.rows = dto;
            }

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    };

    //=======================================
    // loadActionLinks
    //=======================================
    loadActionLinks() {

        //Load the form fields
        let actions = [];
        if (this._selectedEntity == "Assets" && this._isLanguageSelected) {
            actions.push(new FormAction("act_edit_translation", "Edit Translation"));

        }
        actions.push(new FormAction("act_asset_narrative_translation_export", "Asset & Narrative Translation Export"));

        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

    }


    //=======================================
    // loadAsset
    //=======================================
    loadAssets(fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/translation/getAssetTranslations",
            args: {
                isActive_filter: this._isActiveFilter ? true : this._isInactiveFilter ? false : null,
                practice_type_filter: this._selectedAssetTypeFilter.practice_type_code,
                language_id: this._selectedLanguage.language_id,
                entity_name: this._entity_name,
                attribute_name: this._attribute_name
            }
        })
            .then(res => {
                console.log("[{0}:/translation/getAssetTranslations] - res:".format(this._componentName), res);
                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    };

    //==================================
    // loadAssetTypes
    //==================================
    loadAssetTypes(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: null,
                includeAll: false
            }
        })
            .then(res => {
                console.log("[{0}:/practices/getPracticeTypeCodes] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                try {
                    //Build the asset types list
                    this._assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code: "" }].concat(dto);
                    this._selectedAssetTypeFilter = this._assetTypeFilters[0];
                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:loadAssetTypes()]".format(this._componentName), err);
                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                if (fnOnError) { fnOnError(); }
            });

    }

    //=======================================
    // loadLanguages
    //======================================
    loadLanguages(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/translation/getAllLanguages"
        })
            .then(res => {
                console.log("[{0}:/translation/getAllLanguages] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                try {
                    //Build the language list
                    this._languages = [{ language_id: 0, language_name: "" }].concat(dto);
                    this._languagesExport = [{ language_id: 0, language_name: "" }].concat(dto);
                    this._selectedLanguage = this._languages[0];
                    this._selectedLanguageExport = this._languagesExport[0];
                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:loadLanguages()]".format(this._componentName), err);
                    if (fnOnError) { fnOnError(); }
                }            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });

    };


    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //=======================================
    // markAssetGridAsLoading
    //=======================================
    markAssetGridAsLoading(isLoading) {

        if (this.assetGrid) {
            this.assetGrid.MarkAsLoading(isLoading);
        }
        else {
            this._assetGridSettings.loading = isLoading;
        }
    }


    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_savesessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //=======================================
    // addTranslation
    //=======================================
    addTranslation() {

        //Do we have any changes?
        if (this.attribute_value == "") {
            this.growlBox.addGrowl("warn", "Please add a translation before saving");
            return;
        }

        //Populate dto with updates
        let dto = new dto_for_DV1_AddTranslation_Request();
        dto.language_id = this._selectedLanguage.language_id;
        dto.entity_name = this._entity_name;
        dto.entity_id = this._selectedAssetId;
        dto.attribute_name = this._attribute_name;
        dto.attribute_value = this._attribute_value;
        dto.publish = this._publish ? 'Y' : 'N';

        //Prep for save
        this.casNavBoxService.DisableAllLinks();
        this.markAssetGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Translation...");

        //Do the deed
        this.webServices.Post("/translation/addTranslation", dto)
            .then(res => {
                //Check for validation errors
                if (res.Success) {
                    this.growlBox.addGrowl("success", "Record Saved.");
                    this.casNavBoxService.EnableAllLinks();

                    //Refresh all references to the updated translation
                    this.initAssetGrid();
                    this.markAssetGridAsLoading(false);
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-TRBL-AT":
                            this.growlBox.addGrowl("error", "No translation provided to change.");
                            break;
                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }
            })
            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markAssetGridAsLoading(false);
            });

        //Close the dialog
        this.popEditAssetTranslation.Close();


    }

    //=======================================
    // updateTranslation
    //=======================================
    updateTranslation() {

        //Do we have any changes?
        if (this._attribute_value == "" || (this._attribute_value == this._previousAttributeValue && this._publish == this._previousPublish)) {
            this.growlBox.addGrowl("warn", "No changes detected");
            return;
        }
        if (this._attribute_value == "" && this._publish) {
            this.growlBox.addGrowl("warn", "Please add a translation before publishing");
            return;
        }

        //Populate dto with updates
        let dto = new dto_for_DV1_UpdateTranslation_Request();
        dto.language_translation_id = this._selectedTranslationId;
        dto.attribute_value = this._attribute_value;
        dto.publish = this._publish ? 'Y' : 'N';

        //Prep for save
        this.casNavBoxService.DisableAllLinks();
        this.markAssetGridAsLoading(true);
        this.growlBox.addGrowl("info", "Saving Translation...");

        //Do the deed
        this.webServices.Post("/translation/updateTranslation", dto)
            .then(res => {
                //Check for validation errors
                if (res.Success) {
                    this.growlBox.addGrowl("success", "Record Saved.");
                    this.casNavBoxService.EnableAllLinks();

                    //Refresh all references to the updated translation
                    this.initAssetGrid();
                    this.markAssetGridAsLoading(false);
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-TRBL-UT":
                            this.growlBox.addGrowl("error", "No translation provided to change.");
                            break;
                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }
            })
            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markAssetGridAsLoading(false);
            });

        //Close the dialog
        this.popEditAssetTranslation.Close();


    }

    //=======================================
    // saveTranslation
    //=======================================
    saveTranslation() {
        let isValid = this.casValidate.isAllValid(true, "popEditAssetTranslation_body");

        if (!isValid) {
            this.growlBox.addGrowl("warn", "Please enter translation before saving.")
            return;
        }

        if (this._selectedTranslationId == 0) {

            this.addTranslation();
        }

        else {
            this.updateTranslation();
        }

    }

};